import {useState} from 'react';
import {useDispatch} from "react-redux";
import {message} from "antd";
import IntlMessage from "../../../../../../components/IntlMessage/IntlMessage";
import MicroQualificationService from "../../../../../../services/MicroQualificationService";
import {getMicroQualificationById} from "../../../../../../store/slices/MicroqualificationSaveSlice";
import {LANGUAGES} from "../constants/languages";

export const useMicroQualificationSave = (id, form) => {
    const dispatch = useDispatch();
    const [isLoadingSave, setIsLoadingSave] = useState(false);

    const saveStep = async (currentStep, formValues) => {
        try {
            setIsLoadingSave(true);

            switch (currentStep) {
                case 0:
                    await saveFirstStepData(formValues);
                    break;
                case 1:
                    await saveSecondStepData(formValues);
                    break;
                case 2:
                    await saveThirdStepData(formValues);
                    break;
                case 3:
                    await saveFourthStepData(formValues);
                    break;
                case 4:
                    await saveFifthStepData(formValues);
                    break;
                case 5:
                    await saveSixStepData(formValues);
                    break;
                case 6:
                    await saveSevenStepData(formValues);
                    break;
                case 7:
                    await saveEightStepData(formValues);
                    break;
                default:
                    break;
            }
        } catch (error) {
            console.error("Ошибка при сохранении данных:", error);
            throw error;
        } finally {
            setIsLoadingSave(false);
        }
    };

    const saveFirstStepData = async (values) => {
        const selectedObjects = LANGUAGES.filter(lang =>
            values.learnLanguages?.includes(lang.rus)
        );

        const learnLanguages = {
            rus: selectedObjects.map(l => l.rus).join(', '),
            kaz: selectedObjects.map(l => l.kaz).join(', '),
            eng: selectedObjects.map(l => l.eng).join(', ')
        };
        
        await MicroQualificationService.saveFirstStepData(
            id,
            values.licenceNumber,
            values.creditNum,
            values.levelOfNQF,
            values.isAccreditationExist || false,
            learnLanguages.rus,
            learnLanguages.kaz,
            learnLanguages.eng,
            values.isLearnOffline || false,
            values.isLearnOnline || false,
            values.isLearnMixed || false,
            values.professionalStandards || []
        );

        message.success(<IntlMessage id={'success'}/>);
        dispatch(getMicroQualificationById({id}));
    };

    const saveSecondStepData = async (values) => {
        await MicroQualificationService.saveSecondStepData(
            id,
            values.educationField,
            values.trainingDirection,
            values.groupEP,
            values.partnerOrg,
            values.mainDirectionRu,
            values.mainDirectionKz,
            values.mainDirectionEng,
            values.goalRu,
            values.goalKz,
            values.goalEng
        );

        message.success(<IntlMessage id={'success'}/>);
        dispatch(getMicroQualificationById({id}));
    };

    const saveThirdStepData = async (values) => {
        await MicroQualificationService.saveThirdStepData(
            id,
            values.opTasks
        );

        message.success(<IntlMessage id={'success'}/>);
        dispatch(getMicroQualificationById({id}));
    };

    const saveFourthStepData = async (values) => {
        await MicroQualificationService.saveFourthStepFirstData(
            id,
            values.opDescOfCandORu,
            values.opDescOfCandOKz,
            values.opDescOfCandOEng
        );

        const competencesWithNumbers = values.opCompetences?.map((item, index) => ({
            ...item,
            number: index + 1
        })) || [];

        await MicroQualificationService.saveFourthStepSecondData(
            id,
            competencesWithNumbers
        );

        message.success(<IntlMessage id={'success'}/>);
        dispatch(getMicroQualificationById({id}));
    };

    const saveFifthStepData = async (values) => {
        const resultsWithNumbers = values.opResults?.map((item, index) => ({
            ...item,
            number: index + 1
        })) || [];

        await MicroQualificationService.saveFifthStepData(
            id,
            resultsWithNumbers
        );

        message.success(<IntlMessage id={'success'}/>);
        dispatch(getMicroQualificationById({id}));
    };

    const saveSixStepData = async (formValues) => {
        const connections = formValues.connections || {};
        const relations = Object.keys(connections)
            .filter(key => connections[key])
            .reduce((acc, key) => {
                const [competenceId, resultId] = key.split('_');
                if (!acc[resultId]) {
                    acc[resultId] = [];
                }
                acc[resultId].push(competenceId);
                return acc;
            }, {});

        await MicroQualificationService.saveSixStepData(id, relations);

        message.success(<IntlMessage id={'success'}/>);
        dispatch(getMicroQualificationById({id}));
    };

    const saveSevenStepData = async (values) => {
        await MicroQualificationService.saveSevenStepData(
            id,
            values.opDisciplines
        );

        message.success(<IntlMessage id={'success'}/>);
        dispatch(getMicroQualificationById({id}));
    };

    const saveEightStepData = async (values) => {
        await MicroQualificationService.saveEightStepData(
            id,
            values.opAuthors
        );

        message.success(<IntlMessage id={'success'}/>);
        dispatch(getMicroQualificationById({id}));
    };

    const save = async (currentStep, additionalData = {}) => {
        try {
            const values = await form.validateFields();
            await saveStep(currentStep, {...values, ...additionalData});
        } catch (error) {
            if (error?.errorFields) {
                console.log("Validation error!", error);
            } else {
                message.error(<IntlMessage id={'error'}/>);
            }
            throw error;
        }
    };

    return {
        save,
        isLoadingSave
    };
};
